import { render, staticRenderFns } from "./groupStatus.vue?vue&type=template&id=6529d812&"
import script from "./groupStatus.vue?vue&type=script&lang=js&"
export * from "./groupStatus.vue?vue&type=script&lang=js&"
import style0 from "./groupStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports